// Note: ICON Source: https://icons.getbootstrap.com/

import variables from "../styles/utils.module.scss";

// @ts-ignore
export default function IconButton({
  iconName,
  iconSize = 14,
  iconColor,
  title,
  onClick,
  active = false,
}) {
  if (!title) {
    console.error(`ERR: Missing icon title!`);
    return <></>;
  }

  if (!iconColor) {
    iconColor = variables.darkGrey;
  }

  return (
    <div
      onClick={onClick}
      style={{
        backgroundColor: active ? variables.green : variables.pureWhite,
        display: "flex",
        flexGrow: 0,
        alignItems: "center",
        justifyContent: "center",
        border: `1px solid ${active ? variables.green : variables.grey}`,
        borderRadius: "3px",
        height: 38,
        padding: "5px 15px",
        cursor: "pointer",
      }}
    >
      <div style={{ marginRight: "5px" }}>
        <i
          className={`bi bi-${iconName}`}
          style={{
            fontSize: iconSize,
            color: active ? variables.white : variables.black,
          }}
        ></i>
      </div>
      <div
        style={{
          lineHeight: "16px",
          fontSize: "14px",
          color: active ? variables.white : variables.black,
        }}
      >
        {title}
      </div>
    </div>
  );
}
